module.exports = __webpack_public_path__ + "img/Icon__Province_2.575bb9af.svg";